


  import dep0 from "ember-modifier/-embroider-implicit-modules.js";
  import dep1 from "ember-modify-based-class-resource/-embroider-implicit-modules.js";
  import dep2 from "ember-resources/-embroider-implicit-modules.js";
  import dep3 from "reactiveweb/-embroider-implicit-modules.js";
  import dep4 from "tracked-built-ins/-embroider-implicit-modules.js";
  import dep5 from "@embroider/macros/-embroider-implicit-modules.js";
  import dep6 from "ember-tracked-storage-polyfill/-embroider-implicit-modules.js";


export default Object.assign({},
    dep0,
    dep1,
    dep2,
    dep3,
    dep4,
    dep5,
    dep6,
  {
  }
);
